import { VideoInfoType } from '../models/dynamic-form-v3.models';
import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class VideoQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.VIDEO;
  video: VideoInfoType;
  type: string;

  constructor(options: any = {}) {
    super(options);
    this.video = options['video'] || '';
  }
}
